<template>
  <div>
  <van-nav-bar title="收货地址" left-text="" left-arrow @click-left="onClickLeft()" />
  <div v-if="!isLogined" style="padding-top:300px;">
        <p>您还没有登录哦，请先登录</p>
        <van-button round @click="ShowLogin" type="info">点击登录</van-button>
    </div>
    <div v-else>
      <!-- <van-button icon="plus" type="info" size="small" @click="onAdd">添加地址</van-button> -->
      <van-address-list 
        v-model="chosenAddressId" 
        :list="addrslist" 
        default-tag-text="默认"
        @add="onAdd" 
        @edit="onEdit"
        switchable=false>
        <div slot="top">
          <div v-if="isLoading" class="empty-box">
            <van-loading size="24px">加载中...</van-loading>
          </div>
          <div v-else-if="!addrslist || addrslist.length<1" class="empty-box">尚未添加过地址</div>
        </div>
      </van-address-list>
      
    </div>
  </div>
  
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, NavBar, AddressList } from "vant";
import { Button, Field } from "vant";
import { Divider } from "vant";
import { Popup } from "vant";
import { CountDown } from 'vant';
import { Dialog } from 'vant';
export default {
  name: "ReciveAddrs",
  data() {
    return {
      sdworkerid: 0,
      chosenAddressId: 0,      
      addrlist: [],
      addrslist: [],
      isLoading: true,
      skuid: "",
      sku_id: 0,
      product_id: 0,
      count: 0,
      from: "",
    };
  },
  props: {},
  computed:{
    isLogined(){return this.$store.state.isLogin}
  },
  methods: {
    ShowLogin(){
      // this.$store.commit("showLogin");
      this.$router.push({
        name: "Login",
        params: {},
      });
    },
    /*加载收货地址 */
    GetAddrsData(){
      var that=this;
      if(this.isLogined){
        this.isLoading = false;
        that.$http.get("Prizes/GetAddrsPageList").then(res=>{        
          that.addrlist=res.data.ListData;

          that.addrslist = that.addrlist.map(item => {
            return {
              id: item.ID,
              name: item.ContractName,
              tel: item.ContractTel,
              address: item.RegionFullDesc+item.DetailAddr,
              isDefault: item.IsDefault==1?true:false 
            }
          });
        });
      }
    },
    /*新增地址 */
    onAdd() {
      this.$router.push({
        name: "PrizeAddrsEdit",
        params: {addrid: 0},
      });
    },
    /*编辑地址 */
    onEdit(item, index) {
      this.$router.push({
        name: "PrizeAddrsEdit",
        params: {addrid: item.id},
      });
    },
    /*返回 */
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  created() {
    this.GetAddrsData();
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CountDown.name]:CountDown,
    [NavBar.name]: NavBar,
    [AddressList.name]: AddressList,
  },
};
</script>

<style scoped>
    .van-panel {
    margin-top: 20px;
  }

.van-address-list__bottom {
    position: relative;
    margin-top: 30px;
}
</style>
